<template lang="pug">
  section.image-element(:class="classes" :style="style")
    .wrap(:class="imageCounter")
      Images(
        v-for="(slide, i) in slides" :key="slide.id"
        :slide="slide"
      )
</template>

<script>
import { get, cloneDeep } from '@/helpers';
import section from '@/mixins/section';

import Images from './Images';

export default {
  name: 'ImageSection',
  mixins: [section],
  props: {
    section: {
      type: Object,
      required: true
    }
  },
  components: {
    Images
  },
  computed: {
    slides() {
      let slides = this.section.contents || [];
      return cloneDeep(slides).sort((a, b) => get(a, 'position', 0) - get(b, 'position', 0));
    },
    imageCounter() {
      return 'items-' + this.slides.length;     
    },
    content() {
      return get(this.section, 'contents.0');
    },
  }
};
</script>

<style lang="sass" scoped>
@import '~@/assets/sass/variables'

.image-element
  .wrap
    @apply grid grid-cols-1 gap-2
    &.items-1::v-deep
      .overlay-title
        @screen md
          width: 50%
          max-width: 556px
    &.items-2
      @screen sm
        @apply grid-cols-2
    ::v-deep
      .picture-container
        @apply h-full w-full
        figure
          @apply w-full h-full
          @screen md
            height: 364px
          @screen lg
            height: 492px
          @screen xl
            height: 620px
          picture
            @apply w-full h-full inline-block
          img
            object-fit: cover
</style>
